import { UpdateStamp } from './UpdateStamp'

export class ResponseAttachment extends UpdateStamp{
    ResponseAttachmentId: number
    AzureFileId: number
    ResponseId: number
    Response: Response
}